/**
 * Formato de montos, conteos y fechas — `conciliador-ssr/docs/DESIGN.md` §4.
 *
 * Mismas funciones que `frontend/src/lib/format.ts` de Concilia y Gestión.
 * `formatCLP` de `lib/api.ts` delega en `pesos` (mismo resultado); el código
 * nuevo usa este módulo directo.
 */

const PESOS = new Intl.NumberFormat("es-CL", { maximumFractionDigits: 0 });

/** `$1.234.567` (sin decimales; negativo con signo). */
export function pesos(n: number): string {
  const texto = PESOS.format(Math.abs(n));
  // Un negativo que redondea a cero no lleva signo ("-$0" no es un monto).
  return n < 0 && texto !== "0" ? `-$${texto}` : `$${texto}`;
}

/** Para KPI: `$12,35 M` desde un millón, `$850.000` bajo eso. */
export function pesosCortos(n: number): string {
  const abs = Math.abs(n);
  if (abs < 1_000_000) return pesos(n);
  const millones = new Intl.NumberFormat("es-CL", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(abs / 1_000_000);
  return `${n < 0 ? "-" : ""}$${millones} M`;
}

/** Conteo con separador de miles: `20.803`. */
export function cantidad(n: number): string {
  return PESOS.format(n);
}

/** Negativo en rojo; positivo sin color. */
export function claseMonto(n: number): string {
  return n < 0 ? "text-rose-600" : "";
}

/** `26/09/2026` desde `2026-09-26` (sin pasar por Date: no corre por zona horaria). */
export function fechaLarga(iso: string | null | undefined): string {
  if (!iso) return "—";
  const [a, m, d] = iso.slice(0, 10).split("-");
  return `${d}/${m}/${a}`;
}

/** `26/09`. */
export function fechaCorta(iso: string | null | undefined): string {
  if (!iso) return "—";
  const [, m, d] = iso.slice(0, 10).split("-");
  return `${d}/${m}`;
}

const MESES = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
];

/** `junio 2026` desde `2026-06-30`. */
export function mesAnio(iso: string | null | undefined): string {
  if (!iso) return "—";
  const [a, m] = iso.split("-");
  return `${MESES[Number(m) - 1] ?? ""} ${a}`;
}

export function nombreMes(mes: number): string {
  return MESES[mes - 1] ?? "";
}
